import { useDispatch } from "react-redux";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { ApiRequestError, ApiResponse } from "types/api";

import {
  ApiServerErrorMetaMatchingVariantVersion,
  TiVoAppVariantVersion,
  TiVoAppVariantVersionInput,
} from "./types";

export const useUpdateVariant = (id?: string, variantId?: string) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation<
    ApiResponse<TiVoAppVariantVersion>,
    ApiRequestError<ApiServerErrorMetaMatchingVariantVersion>,
    Partial<TiVoAppVariantVersionInput>
  >({
    mutationFn: async (data) => {
      const strict = data.strict ?? true;

      return dispatch(
        apiThatThrows.createTiVoVariantVersion.action({
          params: { id, variantId },
          options: {
            body: JSON.stringify({
              data: {
                type: "TiVoAppVariantVersion",
                attributes: {
                  ...data,
                  strict,
                },
              },
            }),
          },
        })
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["variant", id, variantId] });
    },
  });
};
